export default __webpack_public_path__ + "static/media/ultraabout.240329b4.jpg";